import {
  AcademicCapIcon,
  AdjustmentsHorizontalIcon,
  ArrowUpTrayIcon,
  ArrowsRightLeftIcon,
  BanknotesIcon,
  BookOpenIcon,
  BuildingLibraryIcon,
  BuildingOffice2Icon,
  ChartBarSquareIcon,
  ChatBubbleLeftRightIcon,
  CheckBadgeIcon,
  ClipboardDocumentCheckIcon,
  RectangleGroupIcon,
  Squares2X2Icon,
  UserGroupIcon,
  UserPlusIcon,
  UsersIcon,
} from '@heroicons/react/24/outline';

/**
 * Admin dashboard menu items (tabs).
 * Order of items here defines the order in the admin nav.
 * Content is rendered by AdminDashboard via a menu-driven dispatcher (see config README).
 */
export const adminMenuItems = [
  { id: 'overview', label: 'Overview', group: null, icon: Squares2X2Icon },

  { id: 'cycles', label: 'Feedback Configuration', group: 'Feedback Configuration', icon: AdjustmentsHorizontalIcon },
  { id: 'feedback-lifecycle', label: 'Student Feedback Cycle', group: 'Feedback Configuration', icon: ChatBubbleLeftRightIcon },
  { id: 'faculty-feedback', label: 'Faculty Feedback Cycle', group: 'Feedback Configuration', icon: AcademicCapIcon },
  { id: 'admission-feedback', label: 'Admission Feedback Cycle', group: 'Feedback Configuration', icon: ClipboardDocumentCheckIcon },
  { id: 'parent-alumni-feedback', label: 'Parent, Alumni & Other Cycles', group: 'Feedback Configuration', icon: UserGroupIcon },
  { id: 'feedback-approval', label: 'Approvals & Activation', group: 'Feedback Configuration', icon: CheckBadgeIcon },

  { id: 'departments', label: 'Departments', group: 'Feedback Control', icon: BuildingOffice2Icon },
  { id: 'degrees', label: 'Programs (UG / PG)', group: 'Feedback Control', icon: BookOpenIcon },
  { id: 'divisions', label: 'Semesters / Divisions', group: 'Feedback Control', icon: RectangleGroupIcon },
  { id: 'subjects', label: 'Subjects', group: 'Feedback Control', icon: BuildingLibraryIcon },
  { id: 'assign', label: 'Subject & Faculty Allocation', group: 'Feedback Control', icon: ArrowsRightLeftIcon },

  { id: 'students', label: 'Students', group: 'Stakeholders / Users', icon: UsersIcon },
  { id: 'faculty', label: 'Faculty', group: 'Stakeholders / Users', icon: AcademicCapIcon },
  { id: 'upload', label: 'Upload Stakeholders', group: 'Stakeholders / Users', icon: ArrowUpTrayIcon },
  { id: 'users', label: 'Add Stakeholder / User', group: 'Stakeholders / Users', icon: UserPlusIcon },

  { id: 'institute-profile', label: 'Institute Profile', group: 'Administration', icon: BuildingOffice2Icon },
  { id: 'billing', label: 'Subscription / Billing', group: 'Administration', icon: BanknotesIcon },
  { id: 'reports', label: 'Reports & Analytics', group: 'Reports', icon: ChartBarSquareIcon },
];

export const adminMenuGroups = adminMenuItems.filter((item) => item.group).reduce((groups, item) => {
  const existing = groups.find((group) => group.label === item.group);
  if (existing) {
    existing.items.push(item);
  } else {
    groups.push({ label: item.group, items: [item] });
  }
  return groups;
}, []);

/** Default tab when none is selected or in URL */
export const DEFAULT_ADMIN_MENU_ID = adminMenuItems[0]?.id ?? 'overview';

/** Set of valid menu ids for URL/state validation */
const _validIds = new Set(adminMenuItems.map((i) => i.id));

/** Returns true if id is a known menu id */
export function isValidAdminMenuId(id) {
  return id && _validIds.has(id);
}
